import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import type { LocalDashboardAction } from '../utils/dashboardLocalActions';

interface QuickActionsBarProps {
  actions: LocalDashboardAction[];
}

export const QuickActionsBar: React.FC<QuickActionsBarProps> = ({ actions }) => {
  const navigate = useNavigate();
  if (!actions.length) return null;

  return (
    <div className="d-flex flex-wrap gap-2 mb-4">
      {actions.map((action) => (
        <Button
          key={action.key}
          variant="outline-primary"
          size="sm"
          onClick={() => navigate(action.path)}
        >
          {action.label}
        </Button>
      ))}
    </div>
  );
};

interface ConfigShortcutsProps {
  shortcuts: LocalDashboardAction[];
}

export const ConfigShortcuts: React.FC<ConfigShortcutsProps> = ({ shortcuts }) => {
  const navigate = useNavigate();
  if (!shortcuts.length) return null;

  return (
    <Card className="ntcog-card dashboard-section-card mb-4">
      <Card.Header>System Configuration</Card.Header>
      <Card.Body>
        <div className="dashboard-config-grid">
          {shortcuts.map((shortcut) => (
            <button
              key={shortcut.key}
              type="button"
              className="dashboard-config-card"
              onClick={() => navigate(shortcut.path)}
            >
              <span className="dashboard-config-card__title">{shortcut.label}</span>
            </button>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};
